export default __webpack_public_path__ + "static/media/moon_logo.d9085451.svg";